/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { ASSETS, FOD_URL } from "../../lib/assets";

const links = [
    { label: "Financement", to: "/financement" },
    { label: "Frais bancaires", to: FOD_URL, external: true },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    // Close mobile menu on route change
    useEffect(() => {
        setOpen(false);
    }, [location.pathname, location.hash]);

    // Lock body scroll when mobile menu open
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <header
            data-testid="navbar"
            className="sticky top-0 z-50 bg-white border-b border-dmb-border"
        >
            <div className="container-dmb flex items-center justify-between min-h-[84px] gap-6">
                <Link
                    to="/"
                    data-testid="navbar-logo"
                    aria-label="DMB Partners, accueil"
                    className="flex items-center"
                >
                    <img
                        src={ASSETS.logo}
                        alt="DMB Partners"
                        className="h-6 w-auto"
                    />
                </Link>

                {/* Desktop nav */}
                <nav
                    aria-label="Navigation principale"
                    className="hidden lg:flex items-center gap-8 text-[15px] font-medium"
                >
                    {links.map((l) =>
                        l.external ? (
                            <a
                                key={l.label}
                                href={l.to}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-dmb-navy hover:text-dmb-green-dark transition-colors whitespace-nowrap inline-flex items-center gap-1"
                            >
                                {l.label}
                                <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2.4} />
                            </a>
                        ) : (
                            <NavLink
                                key={l.label}
                                to={l.to}
                                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) =>
                                    `relative py-2 whitespace-nowrap transition-colors ${
                                        isActive && !l.to.includes("#")
                                            ? "text-dmb-green-dark"
                                            : "text-dmb-navy hover:text-dmb-green-dark"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ),
                    )}
                </nav>

                {/* Desktop CTA */}
                <Link
                    to="/contact"
                    data-testid="nav-cta-contact"
                    className="hidden lg:inline-flex btn-dmb btn-primary !h-11 !px-5 text-[14px]"
                >
                    Présenter un projet
                </Link>

                {/* Mobile: Contact + Burger */}
                <div className="flex lg:hidden items-center gap-2">
                    <Link
                        to="/contact"
                        data-testid="mobile-nav-cta-contact"
                        className="btn-dmb btn-primary !h-10 !px-4 text-[13px]"
                    >
                        Contact
                    </Link>
                    <button
                        type="button"
                        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
                        aria-expanded={open}
                        data-testid="navbar-mobile-toggle"
                        onClick={() => setOpen((v) => !v)}
                        className="w-11 h-11 inline-flex items-center justify-center rounded-md border border-dmb-border text-dmb-navy"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {/* Mobile drawer */}
            {open && (
                <div
                    className="lg:hidden border-t border-dmb-border bg-white"
                    data-testid="navbar-mobile-drawer"
                >
                    <nav
                        aria-label="Navigation mobile"
                        className="container-dmb py-5 flex flex-col"
                    >
                        {links.map((l) =>
                            l.external ? (
                                <a
                                    key={l.label}
                                    href={l.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="py-4 border-b border-dmb-border-soft text-dmb-navy inline-flex items-center justify-between font-medium"
                                >
                                    {l.label}
                                    <ArrowUpRight className="w-4 h-4 text-dmb-green-dark" />
                                </a>
                            ) : (
                                <Link
                                    key={l.label}
                                    to={l.to}
                                    data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="py-4 border-b border-dmb-border-soft text-dmb-navy font-medium"
                                >
                                    {l.label}
                                </Link>
                            ),
                        )}
                        <Link
                            to="/contact"
                            className="btn-dmb btn-primary mt-6"
                            data-testid="mobile-nav-cta-full"
                        >
                            Présenter un projet
                        </Link>
                    </nav>
                </div>
            )}
        </header>
    );
}
